import {
  RETRIEVE_FIRST_USER,
  RETRIEVE_ASSOCIATED_USER,
  RETRIEVE_CHATS,
  CLEAR_CHATS,
  CLEAR_ASSOCIATED_USERS,
  DISPATCH_CHAT_ROOM_ID,
  DISPATCH_CHAT_PREVIOUS_ROOM_ID,
  DISPATCH_LOADING_CHAT,
  DISPATCH_IS_TYPING,
  DISPATCH_IS_TYPING_RES,
  DISPATCH__BUYER_CHAT,
  DISPATCH_SELLER_CHAT,
  DISPATCH_BUYER_CHAT_LAST_MESSAGE,
  DISPATCH_SELLER_CHAT_LAST_MESSAGE,
} from "../actions/types";

const initialState = {
  firstUser: [],
  associatedUser: [],
  roomId: [],
  chats: [],
  buyerChat: [],
  sellerChat: [],
  buyerLastMessage: [],
  sellerLastMessage: [],
  unreadCount: [],
  isTyping: false,
  loadingChat: false,
  isTypingRes: {},
  previousRoomId: null,
  room: null,
  currentPage: 1,
};

const chatReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case RETRIEVE_FIRST_USER:
      return {
        ...state,
        firstUser: payload,
      };
    case RETRIEVE_ASSOCIATED_USER:
      return {
        ...state,
        associatedUser: payload,
      };
    case RETRIEVE_CHATS:
      return {
        ...state,
        chats: payload,
      };
    case CLEAR_CHATS:
      return {
        ...state,
        chats: [],
      };

    case CLEAR_ASSOCIATED_USERS:
      return {
        ...state,
        associatedUser: [],
      };

    case DISPATCH__BUYER_CHAT:
      return {
        ...state,
        buyerChat: payload,
      };
    case DISPATCH_SELLER_CHAT:
      return {
        ...state,
        sellerChat: payload,
      };

    case DISPATCH_CHAT_ROOM_ID:
      return {
        ...state,
        room: payload,
      };
    case DISPATCH_CHAT_PREVIOUS_ROOM_ID:
      return {
        ...state,
        previousRoomId: payload,
      };

    case DISPATCH_BUYER_CHAT_LAST_MESSAGE:
      return {
        ...state,
        buyerLastMessage: payload,
      };
    case DISPATCH_SELLER_CHAT_LAST_MESSAGE:
      return {
        ...state,
        sellerLastMessage: payload,
      };

    case DISPATCH_LOADING_CHAT:
      return {
        ...state,
        loadingChat: payload,
      };

    case DISPATCH_IS_TYPING:
      return {
        ...state,
        isTyping: payload,
      };
    case DISPATCH_IS_TYPING_RES:
      return {
        ...state,
        isTypingRes: payload,
      };
    default:
      return state;
  }
};

export default chatReducer;
